var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-navigation-drawer',{attrs:{"absolute":"","right":"","temporary":"","width":"400","loading":""},model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}},[_c('v-list-item',{attrs:{"loading":""}},[_c('v-list-item-content',[_c('v-list-item-title',[_vm._v("Recently Views Sites")])],1)],1),_c('v-divider'),_c('v-data-table',{attrs:{"hide-default-footer":"","headers":[
      { text: 'YHSI Id', value: 'yHSIId' },
      { text: 'Primary Name', value: 'primaryName' },
    ],"items":_vm.history},on:{"click:row":_vm.openSite}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }